<template>
  <div @mouseleave="disableProgressOptions">
    <h4 class="mb-3">
      <span
        class="bg-pale-blue-green badge badge-pill py-2 px-3 text-white font-weight-normal"
      >
        Meta(s) y Objetivo(s)
      </span>
    </h4>
    <p class="fs-18 font-weight-normal mb-4">
      Complete toda la información solicitada a continuación.
    </p>
    <div v-for="(item, key) in detail.subAreas" :key="item.subAreaId">
      <div class="my-4">
        <div class="my-4" v-if="item.subAreaName">
          <span
            class="sub-area-badge px-3 py-2 bg-white d-inline-block font-weight-bold"
          >
            {{ item.subAreaName }}
          </span>
        </div>
        <div class="px-3">
          <div class="row border-bottom">
            <div
              class="goal-key col-md-1 col-12 py-4 d-flex align-items-center justify-content-center text-white"
            >
              <span>Meta #{{ key + 1 }}</span>
            </div>
            <div class="goal-desc col-md-8 col-12 pt-2 pb-1">
              <span>{{ item.goalDescription }}</span>
            </div>
            <div class="col-md-3 col-12 mb-1">
              <div class="row">
                <div class="col-12 px-2 py-1">
                  <div
                    class="py-2 bg-dark-gray d-flex align-items-center justify-content-center text-white progress-week-title"
                  >
                    Progreso
                  </div>
                </div>
                <div v-for="week in weeks" :key="week.id" class="col px-2">
                  <div
                    class="progress-week border rounded py-2 text-center"
                    :class="{
                      selected: selectedWeek.id === week.id,
                    }"
                  >
                    <span>{{ week.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row my-4">
            <div class="col-md-1 col-12"></div>
            <div class="col-md-8 col-12">
              <span
                class="bg-pale-blue-green fs-16 badge badge-pill py-2 px-4 text-white font-weight-normal"
              >
                Objetivos
              </span>
            </div>
            <div class="col-md-3 col-12"></div>
          </div>
          <div
            class="row border-bottom my-3"
            v-for="(objective, keyO) in item.objectives"
            :key="keyO"
          >
            <div class="col-md-1 col-12"></div>
            <div class="col-md-8 col-12">
              <div class="my-2">
                <p>
                  <span class="mr-3">{{ key + 1 }}.{{ keyO + 1 }}</span>
                  {{ objective.objectiveName }}
                </p>
              </div>
            </div>
            <div class="col-md-3 col-12">
              <div class="row">
                <div
                  v-for="(week, weekKey) in objective.weekDetail"
                  :key="`${keyO}-${week.weekNumber}-po`"
                  class="col p-2 relative"
                  @mouseleave="disableProgressOptions"
                  @click="enableProgressOptions(item, week)"
                >
                  <div
                    v-if="week.availableForWeek"
                    :id="week.objectiveId"
                    class="border rounded p-3 text-center"
                    :class="{
                      'cursor-pointer':
                        selectedWeek.id === week.weekNumber && !readOnly,
                      'was-Invalidated':
                        isValidating && selectedWeek.id === week.weekNumber
                          ? !workedObjectivesId(selectedWeek.id).includes(
                              objective.weekDetail[week.weekNumber - 1]
                                .objectiveId
                            )
                          : false,
                    }"
                    :style="{
                      backgroundColor:
                        (selectedWeek.id !== week.weekNumber || readOnly) &&
                        goalObjectiveProgressSelected(
                          week.objectiveId,
                          week.weekNumber
                        )
                          ? goalObjectiveProgressSelected(
                              week.objectiveId,
                              week.weekNumber
                            ).color
                          : selectedWeek.id === week.weekNumber
                          ? readOnly
                            ? '#f2f2f2'
                            : 'white'
                          : '#f2f2f2',
                    }"
                  >
                    <div
                      v-if="
                        goalObjectiveProgressSelected(
                          week.objectiveId,
                          week.weekNumber
                        )
                      "
                    >
                      <div
                        class="px-1 rounded"
                        :class="{ 'cursor-pointer': !readOnly }"
                        :style="{
                          backgroundColor: goalObjectiveProgressSelected(
                            week.objectiveId,
                            week.weekNumber
                          ).color,
                        }"
                      >
                        <span class="font-weight-bold">
                          {{
                            goalObjectiveProgressSelected(
                              week.objectiveId,
                              week.weekNumber
                            ).name
                          }}
                        </span>
                      </div>
                    </div>
                    <i
                      v-else
                      class="far fa-angle-down"
                      :class="{
                        'text-gray':
                          selectedWeek.id !== week.weekNumber || readOnly,
                      }"
                    ></i>
                  </div>
                  <div
                    v-if="
                      progressLevelEnable ===
                        `${item.subAreaId}${week.objectiveId}${week.weekNumber}`
                    "
                    class="progress-option-container absolute d-flex flex-column justify-content-center py-2 px-1 bg-white rounded shadow"
                    :class="{ 'right-5': weekKey === 3 }"
                  >
                    <div
                      v-for="progressLevel in progressLevels"
                      :key="`${progressLevel.id}-po-id`"
                      class="mx-1"
                    >
                      <div
                        class="cursor-pointer px-3 my-1 text-center rounded font-weight-bold"
                        :style="{ backgroundColor: progressLevel.color }"
                        @click="
                          selectObjectiveProgress({
                            weekId: week.weekNumber,
                            objectiveId: week.objectiveId,
                            progressLevelId: progressLevel.id,
                          })
                        "
                      >
                        {{ progressLevel.name }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!week.availableForWeek"
                    :id="week.objectiveId"
                    class="border rounded p-3 text-center"
                    :style="{ backgroundColor: 'white' }"
                  >
                    N/A
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Error from '@/components/common/Error.vue';

export default {
  name: 'EducationalServiceDetail',
  components: {
    Error,
  },
  props: {
    detail: {
      type: Object,
      dafault: () => ({}),
    },
    selectedWeek: {
      type: Object,
      dafault: () => ({}),
    },
    weeks: {
      type: Array,
      dafault: () => [],
    },
    progressLevels: {
      type: Array,
      dafault: () => [],
    },
    workedObjectives: {
      type: Array,
      dafault: () => [],
    },
    isValidating: {
      type: Boolean,
      dafault: () => false,
    },
    readOnly: {
      type: Boolean,
      dafault: () => false,
    },
  },
  data: () => ({
    progressLevelEnable: null,
    msg: 'Tienes Objetivos sin documentar en este informe de progreso',
  }),
  computed: {
    goalObjectiveProgressSelected() {
      return (objectiveId, weekId) => {
        const goalObjectives = this.goalObjectives(objectiveId);
        const objective = goalObjectives.find((x) => weekId === x.weekId);
        if (!objective) return null;
        return this.progressLevels.find(
          (x) => x.id === objective.progressLevelId
        );
      };
    },
  },
  methods: {
    enableProgressOptions({ subAreaId }, week) {
      if (this.readOnly || this.selectedWeek.id !== week.weekNumber) return;
      this.progressLevelEnable = `${subAreaId}${week.objectiveId}${week.weekNumber}`;
    },
    disableProgressOptions() {
      this.progressLevelEnable = null;
    },
    goalObjectives(objectiveId) {
      return [...this.workedObjectives].filter(
        (x) => objectiveId === x.objectiveId
      );
    },
    selectObjectiveProgress(item) {
      let allObjectives = [...this.workedObjectives];
      if (allObjectives.length === 0) {
        this.$emit('update:workedObjectives', [item]);
        return;
      }
      let goalObjectives = this.goalObjectives(item.objectiveId);
      const objective = goalObjectives.find((x) => item.weekId === x.weekId);
      if (objective) objective.progressLevelId = item.progressLevelId;
      else allObjectives.push(item);

      this.$emit('update:workedObjectives', allObjectives);
      setTimeout(() => {
        this.progressLevelEnable = null;
      }, 50);
    },
    workedObjectivesId(weekId) {
      const objetives = this.workedObjectives
        .filter((x) => x.weekId == weekId)
        .map((x) => x.objectiveId);
      return objetives;
    },
  },
};
</script>
<style scoped lang="scss">
.bg-pale-blue-green {
  background-color: #aabbb5;
}
.sub-area-badge {
  border: 1px solid;
  border-radius: 25px;
  border-color: #b2c1ba;
}

.goal-key {
  background-color: #ff7058;
  border-radius: 5px 5px 0px 0px;
}
.fs-16 {
  font-size: 16px;
}
.fs-18 {
  font-size: 18px;
}
.cursor-pointer {
  cursor: pointer;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
.progress-option-container {
  top: 70px;
  z-index: 1;
}
.right-5 {
  right: 9px;
}

.progress-week.selected {
  background-color: #ffebeb;
  border: solid 1px #fcc9c8 !important;
}
.progress-week {
  background-color: #e7efeb;
  border: solid 1px #b5c3bc !important;
}
.progress-week-title {
  border-radius: 5px 5px 0px 0px;
  background-color: #3f5b60;
}
.was-Invalidated {
  border-radius: 4px;
  border: 1px solid #ff0018 !important;
  background-color: #ffebeb !important;
}
</style>
